import React from "react";
import ReactDOM from "react-dom";
import {ILineItem} from "../../common/cart.models";
import {calls, PROJECT_LANGUAGE, REFURBISHED} from "../../core/APIUtils";
import {RESTContext} from "../../core/rest.context";
import {SliderItems} from "../sliders/slideritems.component";


export const RelatedItemsLayer = () => {
    const container = document.getElementById("reactPlaceholder_relatedProducts");
    const [items, setItems] = React.useState<unknown>([]);
    const [channels, setChannels] = React.useState<string[]>([]);
    const {ajax$} = React.useContext(RESTContext);

    React.useEffect(() => {
        if (container) {
            ajax$(calls.Project.getProduct(container?.getAttribute('data-id') || ""))
                .subscribe((res: ILineItem) => {
                    const auto_vent = res.masterVariant?.attributes.find(attr => attr.name === "AUTO_VENT_2_0")?.value || null;
                    if (auto_vent != null) {
                        const sku = res.masterVariant?.sku
                        ajax$(calls.Project.queryProductProjection('masterVariant(attributes(name%3D"AUTO_VENT_2_0")) and masterVariant(sku!%3D"' + sku + '")'))
                            .subscribe((res: any) => {
                                setItems(res?.results)
                            })
                    } else {
                        const isRefurbish = container?.getAttribute('data-is-refurbish') === 'true'
                        const channels = isRefurbish ? Object.keys(REFURBISHED) : []
                        setChannels(channels)
                        const ri = res.masterVariant?.attributes.find(attr => attr.name === "related-products")?.value || [];
                        const manualRi = res.masterVariant?.attributes.find(attr => attr.name === "manual-related-products")?.value || [];
                        //rimuovo elementi non piu referenziati. (manca il campo obj) e filtro in base al channel
                        const filteredRi = ri.filter((item) => {
                            if (!('obj' in item)) return false;
                            const attributes = item.obj?.masterData?.current?.masterVariant?.attributes ?? [];
                            if (isRefurbish && channels.length > 0) {
                                // mostra solo prodotti refurbish (value 1 o 2. Il 2 ha entrambi i prezzi)
                                return attributes.some((attr: any) => attr.name === "refurbished" && (attr.value === 1 || attr.value === 2));
                            } else {
                                // mostra solo prodotti NON refurbish (value 0 o 2. Il 2 ha entrambi i prezzi)
                                return attributes.some((attr: any) => attr.name === "refurbished" && (attr.value === 0 || attr.value === 2));
                            }
                        })
                        const filteredManualRi = manualRi.filter(item => 'obj' in item)
                        setItems([...filteredManualRi, ...filteredRi]);
                    }
                })
        }
    }, [container]);

    if (!container){
        return null;
    } else {
        return ReactDOM.createPortal(
            <SliderItems items={items} type={"related"} alignTitle={"center"} channels={channels}/>,
            container
        )
    }

};

export const SliderListFromConnectif = () => {
    const [portals, setPortals] = React.useState<{ container: Element; skus: string[]; title?: string }[]>([]);

    React.useEffect(() => {
        const mountedContainers = new WeakSet<Element>();

        const containers = document.getElementsByClassName("reactPlaceholder_productFromConnectif");

        Array.from(containers).forEach((container) => {
            if (mountedContainers.has(container)) return;

            const tryMount = () => {
                const titleSpan = container.querySelector("span.titleFromConnectif");
                const title = titleSpan?.getAttribute("data-title") ?? undefined;

                const spans = container.querySelectorAll("span.skuFromConnectif");
                if (!spans.length) return false;

                const skus = Array.from(spans)
                    .map((el) => el.getAttribute("data-sku"))
                    .filter((sku): sku is string => sku !== null);

                container.innerHTML = "";
                mountedContainers.add(container);

                setPortals((prev) => [...prev, { container, skus, title }]);
                return true;
            };

            // Se il contenuto è già presente, procedi subito
            if (!tryMount()) {
                // Altrimenti osserva il contenuto del container
                const observer = new MutationObserver(() => {
                    if (tryMount()) observer.disconnect();
                });

                observer.observe(container, {
                    childList: true,
                    subtree: true,
                });
            }
        });
    }, []);

    return (
        <>
            {portals.map(({ container, skus, title }, i) => (
                <SliderFromConnectif key={i} container={container} skus={skus} title={title} />
            ))}
        </>
    );
};

export const SliderFromConnectif = (props: any) => {
    const { container, skus, title } = props;
    const [products, setProducts] = React.useState<any>([]);
    const {ajax$} = React.useContext(RESTContext);

    React.useEffect(() => {
        if (container) {
            let products: any [] = []
            const skusString = skus
                .map((sku: string) => `"${sku.trim()}"`)
                .join(", ")
            //esclude i prodotti refurbished = 1 (solo refurbished)
            const where = `masterVariant(sku in (${skusString})) and not(masterVariant(attributes(name="refurbished" and value=1)))`

            ajax$(calls.Project.queryProductProjection(where))
                .subscribe((res: any) => {
                    products = [...products, ...res?.results]

                    //rimuove i duplicati
                    products = products.filter((obj: any, i) => products.findIndex((other: any) => Object.keys(obj).every((key) => obj["key"] === other["key"])) === i)

                    setProducts(products)
                })
        }
    }, [container]);


    if (!container || !products)
        return null;
    else {
        return ReactDOM.createPortal(
            <SliderItems items={products} title={title} type={"related"}/>,
            container
        )
    }

};

export const SliderListFromCategoryCT = () => {
    const container = document.getElementsByClassName("reactPlaceholder_slider");
    return <>
        {Array.from(container).map((slider, i) =>
            <SliderFromCategoryCT container={slider} key={i}/>
        )}
    </>
};

export const SliderFromCategoryCT = (props: any) => {
    const container = props.container;
    const [relatedItems, setRelatedItems] = React.useState<any>([]);
    const [categoryName, setCategoryName] = React.useState<string>();
    const [numberOfSlidesToShow, setNumberOfSlidesToShow] = React.useState<string>();
    const {ajax$} = React.useContext(RESTContext);

    React.useEffect(() => {
        if (container) {
            let title = container.getAttribute('data-title') || undefined
            let categoriesKeyField = container.getAttribute('data-categories-key') || ""
            let numberOfSlidesToShow = container.getAttribute('data-number-of-slides') || ""
            let orderField = container.getAttribute('data-order-field') || "price"
            let orderType = container.getAttribute('data-order-type') || "ASC"
            let categoriesKey: any[] = []
            if (categoriesKeyField) {
                categoriesKey = categoriesKeyField.split(',')
            }

            if (categoriesKey.length > 0) {
                let products: any [] = []
                categoriesKey.forEach((key, i) => {
                    ajax$(calls.Project.getCategoryByKey(key), undefined, {}, false ).subscribe(
                        category => {
                            if (!title && i === 0) {
                                title = category.name[PROJECT_LANGUAGE]
                            }

                            let filterQuery = 'categories.id:"' + category.id + '"&expand=productType&expand=masterVariant.attributes[*].value[*]'
                            switch (orderField){
                                case "default":
                                    filterQuery += '&sort=price%20' + orderType
                                    break;
                                case "price":
                                    filterQuery += '&sort=price%20' + orderType
                                    break;
                                case "availability":
                                    filterQuery += '&sort=variants.availability.availableQuantity%20' + orderType
                                    break;
                                default:
                                    filterQuery += '&sort=price%20' + orderType
                                    break;
                            }


                            ajax$(calls.Project.getProductProjection(filterQuery), undefined, {}, false )
                                .subscribe(
                                    res => {
                                        products = [...products, ...res['results']]
                                    })
                        }
                    )
                })

                //rimuove i duplicati
                products = products.filter((obj: any, i) => products.findIndex((other: any) => Object.keys(obj).every((key) => obj["key"] === other["key"])) === i)
                //rimuove i prodotti solo refurbished (refurbished = 1)
                products = products.filter((product: any) => {
                    const refurbishAttr = product?.masterVariant?.attributes?.find(
                        (attr: any) => attr.name === "refurbished"
                    );

                    return refurbishAttr?.value !== 1;
                });

                setCategoryName(title)
                setRelatedItems(products)
                setNumberOfSlidesToShow(numberOfSlidesToShow)
            }
        }
    }, [container]);


    if (!container || !categoryName || !relatedItems)
        return null;
    else {
        return ReactDOM.createPortal(
            <SliderItems items={relatedItems} title={categoryName} type={"related"} numberOfSlidesToShow={numberOfSlidesToShow}/>,
            container
        )
    }

};
